import {gql} from "@apollo/client";
import {mutate, query} from "../../lib/apollo";
import downloadCsv from "../../lib/downloadCsv";

export const REPORT_FIELDS = `
    companyName
    hpCampaignId
    brokerName
    schoolName
    appId
    campaignGrade
    hoursOldMin
    hoursOldMax
    hpEventId
    hpCampusSearchId
    costPerLead
    dailySent
    dailyCap
    monthlySent
    monthlyCap
    rangeGood
    rangeUnknown
    rangeBad
    campaignActive
    pmActive
`;

export async function searchHpCampaignsReport(input: any) {
    const q = gql`
        query q($input: HpCampaignsReportInput!) {
            hpCampaignsReport(input: $input) {
                ${REPORT_FIELDS}
            }
        }
    `;
    const res = await query(q, {input});
    return res?.hpCampaignsReport || [];
}

export async function updateHpCampaignField(hpCampaignId: number, field: string, value: string) {
    const q = gql`
        mutation m($hpCampaignId: Int!, $field: String!, $value: String!) {
            hpCampaignUpdateField(hpCampaignId: $hpCampaignId, field: $field, value: $value)
        }
    `;
    const res = await mutate(q, {hpCampaignId, field, value});
    return !!res?.hpCampaignUpdateField;
}

export function downloadHpCampaignsCsv(rows: any[], showAll: boolean) {
    const header = [
        "#", "Cmp", "Campaign", "Broker", "School", "App Id",
        ...(showAll ? ["Grade", "Hours Old Min", "Hours Old Max", "Event"] : []),
        "PM", "CPL", "Daily", "Daily Cap", "Monthly", "Monthly Cap", "Good", "Unknown", "Bad",
    ];
    const content: any[][] = [header];
    rows.forEach((r, i) => {
        content.push([
            i + 1,
            r.companyName,
            r.hpCampaignId,
            r.brokerName,
            r.schoolName,
            r.appId,
            ...(showAll ? [r.campaignGrade, r.hoursOldMin, r.hoursOldMax, r.hpEventId] : []),
            r.hpCampusSearchId,
            r.costPerLead,
            r.dailySent,
            r.dailyCap,
            r.monthlySent,
            r.monthlyCap,
            r.rangeGood > 0 ? r.rangeGood : "",
            r.rangeUnknown > 0 ? r.rangeUnknown : "",
            r.rangeBad > 0 ? r.rangeBad : "",
        ]);
    });
    return downloadCsv("campaigns.csv", content);
}

const FIELD_MAP: Record<string, string> = {
    appId: "app_id",
    campaignGrade: "campaign_grade",
    hoursOldMin: "hours_old_min",
    hoursOldMax: "hours_old_max",
    costPerLead: "cost_per_lead",
    dailyCap: "daily_cap",
    monthlyCap: "monthly_cap",
};

export function phpField(uiField: string) {
    return FIELD_MAP[uiField] || uiField;
}
